import InventroyIndexView from "@/views/inventory/InventoryIndexView.vue";
import InventoryRoom from "@/views/inventory/inventoryRoom/InventoryRoom.vue";
import InventorySpoil from "@/views/inventory/inventorySpoil/InventorySpoil.vue";
import InventoryWareHouse from "@/views/inventory/inventoryWarehouse/InventoryWareHouse.vue";

const inventory = [
  {
    path: "/inventory",
    name: "inventory",
    component: InventroyIndexView,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
  {
    path: "/inventorywarehouse",
    name: "inventorywarehouse",
    component: InventoryWareHouse,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
  {
    path: "/inventoryspoil",
    name: "inventoryspoil",
    component: InventorySpoil,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
  {
    path: "/inventoryroom",
    name: "inventoryroom",
    component: InventoryRoom,
    meta: {
      layout: "default",
      role: ["superadmin"],
      public: false,
    },
  },
];

export default inventory;
